module.exports = __webpack_public_path__ + "img/n8.6061cb5b.png";